import React from 'react';
import Icon from '../icon';
export class AlertMessage extends React.Component {
  render() {
    var cls = 'alert-message';
    if (this.props.icon) {
      cls += ' icon';
    }
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    if (this.props.icon) {
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: this.props.icon
      }), /*#__PURE__*/React.createElement("div", null, this.props.message));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, this.props.message);
    }
  }
}
export default {
  AlertMessage
};